import React, { Component } from 'react';
import { Table, Form } from 'react-bootstrap';
import { concepts_payroll } from '../localdata/conceptos';

class DateValueForm extends Component {
    constructor(props) {
        super(props);
        this.myValueRef = React.createRef();
        this.myQuantityRef = React.createRef();
        this.myInitDateRef = React.createRef();
        this.myFinalDateRef = React.createRef();
        this.state = {};
    }

    componentDidMount() { }

    updateInfo = () => {
        const { returnData, concept } = this.props;
        const current_total = this.calcTotal(concept);
        returnData({
            value: (concept !== "11") ? this.myValueRef.current.value : 0,
            total_line: current_total,
            code: concept,
            quantity: this.myQuantityRef.current.value,
            init_date: this.myInitDateRef.current.value,
            final_date: this.myFinalDateRef.current.value,

        })
    }

    calcTotal = (concept) => {
        let quantity = 0
        let value = 0
        if (this.myQuantityRef.current && concept === "11") this.myValueRef.current.value = 0
        quantity = (this.myQuantityRef.current && this.myQuantityRef.current.value !== '') ? parseFloat(this.myQuantityRef.current.value) : 0
        value = (this.myValueRef.current && this.myValueRef.current.value !== '') ? parseFloat(this.myValueRef.current.value) : 0

        // (this.myQuantityRef.current.value || 0) * (this.myValueRef.current.value || 0)
        const total = quantity * value
        return total;
    }
    render() {
        const { concept } = this.props;
        const infoConcept = concepts_payroll.find((c) => c.code === concept)
        const cleanName = infoConcept.description.substring(
            infoConcept.description.indexOf('-') + 1
        ).trim()
        const total_vacaciones = this.calcTotal(concept);
        return (
            <Table striped bordered>
                <thead>
                    <tr>
                        <td>TIPO</td>
                        <td>FECHA INICIO</td>
                        <td>FECHA FIN</td>
                        <td>TOTAL DIAS</td>
                        <td>VALOR</td>
                        <td>TOTAL LINEA</td>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{cleanName}</td>
                        <td><Form.Control ref={this.myInitDateRef} name="init_date" type="date" onChange={this.updateInfo} /></td>
                        <td><Form.Control ref={this.myFinalDateRef} name="final_date" type="date" onChange={this.updateInfo} /></td>
                        <td><Form.Control ref={this.myQuantityRef} name="quantity" type="text" placeholder="Dias" onChange={this.updateInfo}></Form.Control></td>
                        <td><Form.Control ref={this.myValueRef} name="total_line" type="text" placeholder="Valor" onChange={this.updateInfo} disabled={concept === '11'}  ></Form.Control></td>
                        <td className="currSign" style={{ textAlign: 'center' }}>{Intl.NumberFormat('es-MX').format(total_vacaciones)}</td>
                    </tr>
                </tbody>
            </Table>
        );
    }
}
export default (DateValueForm);


// WEBPACK FOOTER //
// ./src/components/nomina/subcomponents/dateValueForm.jsx